import LoginRegisterTransferLink from '@map/components/GuestArea/LoginRegisterTransferLink';
import PhoneVerificationForm from '@map/components/PhoneVerificationForm';
import { FormattedMessage } from 'react-intl';
import PublicPage from '../../shared/PublicPage';
import { useRegistrationContext } from '../context';

const PhoneVerification: FC = () => {
  const { submit, values } = useRegistrationContext();

  return (
    <PublicPage
      title={<FormattedMessage id="registration.sign_up_button" />}
      footer={<LoginRegisterTransferLink to="login" variant="minimal" />}
    >
      <PhoneVerificationForm phone={values.phone} onSubmit={submit} scope="register" />
    </PublicPage>
  );
};

export default PhoneVerification;
